// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMSettingsLayout.tsx — PropelMapper settings layout scaffold.
//
// A sticky left sub-nav (sectioned nav items) beside a scrolling content pane.
// Use for settings, account, and admin areas. Content is passed as children;
// the active section is controlled. Collapses to stacked on narrow widths.
// All --pm-* tokens.

const PMSET_CSS = `
.pmset{box-sizing:border-box;display:grid;grid-template-columns:232px 1fr;gap:30px;align-items:start;font-family:var(--pm-font-sans)}
.pmset-nav{position:sticky;top:16px;display:flex;flex-direction:column;gap:2px}
.pmset-navgroup-lbl{font:var(--pm-label-m);font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--pm-fg-3);padding:0 12px;margin:16px 0 6px}
.pmset-navgroup-lbl:first-child{margin-top:0}
.pmset-item{box-sizing:border-box;display:flex;align-items:center;gap:11px;width:100%;text-align:left;background:none;border:none;font-family:inherit;font:var(--pm-body-m);font-weight:600;color:var(--pm-fg-2);padding:10px 12px;border-radius:var(--pm-radius-m,8px);cursor:pointer;transition:.1s}
.pmset-item:hover{background:var(--pm-surface-variant);color:var(--pm-fg-1)}
.pmset-item.is-active{background:var(--pm-primary-surface);color:var(--pm-primary-dark);font-weight:700}
.pmset-item .material-symbols-outlined{font-size:20px}
.pmset-content{min-width:0}
@media (max-width:760px){
  .pmset{grid-template-columns:1fr;gap:18px}
  .pmset-nav{position:static;flex-direction:row;flex-wrap:wrap;gap:8px}
  .pmset-navgroup-lbl{display:none}
  .pmset-item{width:auto}
}
`;
function pmsetEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmset-css")) return;
  const s = document.createElement("style"); s.id = "pmset-css"; s.textContent = PMSET_CSS;
  document.head.appendChild(s);
}

const pmsetGlyphVars: any = { "--icon-fg": "currentColor", "--icon-accent": "currentColor" };
function pmsetGlyph(base, size, cls = "") {
  const I = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
  const name = I[base] ? base : (I[base + "-outline"] ? base + "-outline" : null);
  if (name) return <span className={"pm-icon " + cls} aria-hidden="true"
    style={Object.assign({ width: size, height: size }, pmsetGlyphVars)}
    dangerouslySetInnerHTML={{ __html: I[name] }} />;
  return <span className={"material-symbols-outlined " + cls} aria-hidden="true"
    style={{ fontSize: size, lineHeight: 1 }}>{base}</span>;
}

export function PMSettingsLayout({
  sections = [],
  active,
  onSelect,
  className = "",
  style = {},
  children,
  ...rest
}) {
  pmsetEnsureCSS();
  // sections: either a flat list of items, or groups {label, items:[]}
  const grouped = sections.length && sections[0] && sections[0].items
    ? sections
    : [{ label: null, items: sections }];
  return (
    <div className={"pmset" + (className ? " " + className : "")} style={style} {...rest}>
      <nav className="pmset-nav" aria-label="Settings">
        {grouped.map((g, gi) => (
          <React.Fragment key={gi}>
            {g.label ? <div className="pmset-navgroup-lbl">{g.label}</div> : null}
            {(g.items || []).map((it) => (
              <button key={it.id} type="button"
                className={"pmset-item" + (it.id === active ? " is-active" : "")}
                onClick={() => onSelect && onSelect(it.id)}>
                {it.icon ? pmsetGlyph(it.icon, 20) : null}
                <span>{it.label}</span>
              </button>
            ))}
          </React.Fragment>
        ))}
      </nav>
      <div className="pmset-content">{children}</div>
    </div>
  );
}
